import React from 'react';
import './App.css';
import logo from './elucd-logo-blue.svg'
import HomeView from 'app/routes/HomeView'
import FunctionView from 'app/routes/FunctionView'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link, 
  Redirect,
  useHistory
} from "react-router-dom";
import netlifyIdentity from 'netlify-identity-widget';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';


// -- ICONS --
import PinDropIcon from '@material-ui/icons/PinDrop';
import BarChartIcon from '@material-ui/icons/BarChart';
import HomeIcon from '@material-ui/icons/Home';
import SettingsIcon from '@material-ui/icons/Settings';
import SettingsView from 'app/routes/SettingsView';

const netlifyAuth = {
  isAuthenticated: false,
  user: null,
  loggedIn(user, callback) { 
    this.isAuthenticated = true
    this.user = user
    callback(user)
  },
  authenticate(callback) {
    this.isAuthenticated = true;
    netlifyIdentity.open();
    netlifyIdentity.on('login', user => {
      console.log("Logged In")
      this.user = user;
      callback(user);
      netlifyIdentity.close();
    });
  },
  signout(callback) {
    this.isAuthenticated = false;
    netlifyIdentity.logout();
    netlifyIdentity.on('logout', () => {
      this.user = null;
      callback();
    });
  }
};

const AuthButton = () => {
  let history = useHistory();
  function nav() { 
    history.push('/login')
    window.location.reload()
  }
  return(
    netlifyAuth.isAuthenticated ? (
      <ListItem button onClick={() => {
          netlifyAuth.signout(nav);
        }}>
          <ListItemIcon> <ExitToAppIcon color="primary"/> </ListItemIcon>
          <ListItemText primary="Logout" /> 
      </ListItem>
    ) : (
      <p>You are not logged in.</p>
    )

  )
}

function AuthExample() {
  return (
    <Router>
      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute path="/" component={App} />
      </Switch>
    </Router>
  );
}

class Login extends React.Component {
  state = { redirectToReferrer: false };

  login = async () => {
    console.log('Logging in...')
    const user = netlifyIdentity.currentUser()
    // console.log('User:', user)
    if (user) { 
      netlifyAuth.loggedIn(user, () => { 
        console.log("Already logged in...")
        this.setState({ redirectToReferrer: true });
      })
    } else { 
      netlifyAuth.authenticate(() => {
        console.log("Login Successful")
        this.setState({ redirectToReferrer: true });
      });
    }
    console.log("Done!")
  };

  
  componentDidMount = () => { 
    this.login()
  }

  render() {
    let { from } = this.props.location.state || { from: { pathname: '/' } };
    let { redirectToReferrer } = this.state;

    if (redirectToReferrer) return <Redirect to={from} />;

    return (
      <Grid   container
      direction="column"
      justify="center"
      alignItems="center" 
      style={{backgroundColor: '#efefef', height: '100vh'}}>
      
      <img src={logo} style={{width:200, height: 200}} />
      <Paper style={{alignItems: 'center', padding: 20}}>
        <h2>Elucd Processor</h2>
        <Button onClick={this.login} color="primary" variant="contained">Login</Button>

      </Paper>
      </Grid>
    );
  }
}

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        netlifyAuth.isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    flexGrow: 1
  },
  sidebar: { 
    backgroundColor: '#242424', 
    color: '#efefef',
    fontFamily: 'Roboto'
  }, 
  link: { 
    color: 'white', 
    textDecoration: 'none'
  }
}));

let rakeConfig = { 
  tableConfig : [ 
    { title: "Function", id: "function"}, 
    { title: "Date", id: "date"}, 
    { title: "Time", id: "time"}, 
    { title: "Run Type", id: "runType"},
    { title: "Survey Count", id: "data.values.filter_df_size"},
    { title: "Status", id: "status", type: "badge"}, 
  ], 
  logsConfig : [ 
    {id: 'level_0', required: true, default : 'chicago'}, 
    {id: 'date_from', required: true, default : '2020-10-01'}, 
    {id: 'date_to', required: true,  default : '2020-10-15'}, 
    {id: 'id', required: false}, 
  ], 
  funcConfig : { 
    name: "Rake Weighter", 
    path: 'rake'
  }
}

let geoConfig = { 
  tableConfig : [ 
    { title: "Function", id: "function"}, 
    { title: "Date", id: "date"}, 
    { title: "Time", id: "time"}, 
    { title: "Run Type", id: "runType"},
    { title: "Status", id: "status", type: "badge"}, 
    { title: "Level_0", id: "params.id"}, 

  ], 
  logsConfig : [ 
    {id: 'id', required: true, default : 'chicago'}, 
  ], 
  funcConfig : { 
    name: "City Geoguide", 
    path: 'geoguide'
  }
}


function App() {
  const classes = useStyles();

  return (
    <div className="App" style={{backgroundColor:'#efefef', height: '100vh', display: 'flex', overflow: 'none'}}>
      <Router>

      <Grid container spacing={0} alignItems="stretch" style={{height: '100vh', overflow: 'none'}}>

        <Grid className={classes.sidebar} item xs={3} elevation={20} style={{height: '100%'}} >
          <h1><span>
          {/* <img src={logo} /> */}
          </span>Processor</h1>
          <List component="nav" aria-label="main mailbox folders" >
            <Link to="/" className={classes.link}>
              <ListItem button>
                <ListItemIcon> <HomeIcon color="primary"/> </ListItemIcon>
                <ListItemText primary="Home" /> 
              </ListItem>
            </Link> 
            <Link to="/rake" className={classes.link}>
              <ListItem button>
                <ListItemIcon> <BarChartIcon color="primary"/> </ListItemIcon>
                <ListItemText primary="Rake Weighter" /> 
              </ListItem>
            </Link> 
            <Link to="/geoguide" className={classes.link}>
              <ListItem button>
                <ListItemIcon> <PinDropIcon color="primary"/> </ListItemIcon>
                <ListItemText primary="City Geoguide" /> 
              </ListItem>
            </Link> 


          </List>
            <div style={{position: 'absolute', bottom: 10}}>
            <Link to="/settings" className={classes.link}>
              <ListItem button>
                <ListItemIcon> <SettingsIcon color="primary"/> </ListItemIcon>
                <ListItemText primary="Settings" /> 
              </ListItem>
            </Link> 
            <AuthButton />
            </div>
        </Grid>
        <Grid item xs={9} style={{height: '100%', overflow: 'scroll', }}>
          <Switch>
            <Route path="/geoguide"> <FunctionView 
              key="geo"
              tableConfig={geoConfig.tableConfig}
              logsConfig={geoConfig.logsConfig}
              funcConfig={geoConfig.funcConfig}/> 
            </Route>
            <Route path="/rake">
               <FunctionView key="rake"
                tableConfig={rakeConfig.tableConfig}
                logsConfig={rakeConfig.logsConfig}
                funcConfig={rakeConfig.funcConfig}/>
                </Route>
            <Route path="/settings"> <SettingsView /> </Route>

            <Route path="/"> <HomeView /> </Route>
          </Switch>
        </Grid>
     
      </Grid>
      </Router>

    </div>
  );
}





export default AuthExample;
